import './vendor/swiper';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
